// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z0s1","col":"styles_col__1ZWQ2"};